import { Injectable } from '@angular/core';
import {HttpObservable, HttpWrapper} from "../http-helpers/http.wrapper";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class SSOTokenProxy {
  constructor(private httpWrapper: HttpWrapper) {
  }

  public getSSOToken(): HttpObservable<string> {
    return this.httpWrapper.getAnon('PatientPortalAuthSSO', 'GetToken').pipe(map(x => x.token));
  }

  public getSSOTokenForPatient(): HttpObservable<string> {
    return this.httpWrapper.get('PatientPortalAuthSSO', 'GetTokenForPatient').pipe(map(x => x.token));
  }
}
